module.exports = __webpack_public_path__ + "img/slide7.58867b4e.png";